'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'trophy-star';
var width = 512;
var height = 512;
var aliases = ["trophy-alt"];
var unicode = 'f2eb';
var svgPathData = 'M368 0L144 0c-26.5 0-48.1 21.8-47.1 48.2 .2 5.3 .4 10.6 .7 15.8L24 64c-13.3 0-24 10.7-24 24 0 113.7 47.9 177.7 104.2 211.8 21.6 13.1 44 21.5 64.5 26.8 19.4 26.3 39.4 40.6 55.3 48.3l0 73.1-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-73.1c16.6-8 37.7-23.2 57.9-51.8 17.6-5.2 36.1-12.4 54.1-22.5 29.3-16.4 57.6-40.6 78.5-75.7 20.9-35.2 33.5-80.1 33.5-136.8 0-13.3-10.7-24-24-24l-73.6 0c.3-5.2 .5-10.4 .7-15.8 1-26.5-20.6-48.2-47.1-48.2zM48.8 112l52.4 0c6.5 63.6 18.3 112.3 32.8 149.6-1.7-.9-3.3-1.9-5-2.9-37.9-22.9-74.3-65-80.2-146.7zm388.3 88.4c-15.1 25.5-35.4 43.6-57.4 56.5 13.6-36.7 24.8-83.9 31-144.8l52.3 0c-2.9 37.4-12.7 66.1-25.9 88.4zM266.8 85.8l17.5 35.4 39 5.7c9.8 1.4 13.8 13.5 6.6 20.5l-28.2 27.5 6.7 38.9c1.7 9.8-8.6 17.3-17.4 12.7L256 208 221.1 226.4c-8.8 4.6-19.1-2.8-17.4-12.7l6.7-38.9-28.2-27.5c-7.1-6.9-3.2-19 6.7-20.5l39-5.7 17.5-35.4c4.4-8.9 17.1-8.9 21.5 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrophyStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;